import {Collection} from "vue-mc"
import resourceModel from "@/models/resourceModel"

import Vue from "vue";

export default class resourceCategoryCollection extends Collection {

	model() {
		return resourceCategoryModel;
	}

	defaults() {
		return {
			inBuiltApi: Vue.prototype.$interpretersApiUrl,
			methodTypes: 'menu',
			resourceType: 'Videos',
			data: {},
			dbData: {}
		}
	}

	options() {
		return {
			methods: {
				list: 'GET'
			}
		}
	}

	routes() {
		return {
			list: 'interpreter/resources/list/{resourceType}/category'
		}
	}

	requestRoute() {

		let headers = {
			Bearer: localStorage.getItem('jwt')
		};
		let method = this.getOption('methods.' + this.getAttributes().methodTypes);
		let route = this.getAttributes().inBuiltApi + this.getRoute(this.getAttributes().methodTypes);
		let params = this.getRouteParameters();
		let url = this.getURL(route, params);
		let data = this.getAttributes().data;

		// console.log(headers, method, url, data);

		return this.getRequest({headers, method, url, data}).send();
	}

	getList(resourceType) {
		this.getAttributes().methodTypes = 'list';
		this.getAttributes().resourceType = resourceType;
		return this.requestRoute();
	}
}
